
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.625 2c-5.524 0-10 4.476-10 10s4.476 10 10 10 10-4.476 10-10-4.476-10-10-10zm1.363 6.52l3.226-1.935c.468-.279.968.31.62.725L15.48 8.935l1.355 1.625c.35.42-.158 1-.621.726l-3.226-1.935a.487.487 0 010-.83zM6.415 7.31c-.346-.415.154-1.004.621-.725l3.226 1.935a.484.484 0 010 .83l-3.226 1.936c-.463.274-.967-.306-.62-.726L7.77 8.935 6.415 7.31zm11.295 6.706a5.812 5.812 0 01-5.762 5.08h-.646a5.812 5.812 0 01-5.762-5.08.648.648 0 01.641-.726h10.887c.388 0 .69.339.642.726z","fill":"#525F7F"}})])
          )
        }
      }
    